import { useSSOContext } from "lib/contexts/SSOProvider";
import useSWR from "swr";
import { postRequest, staticOptions } from "lib/core/apiClient";
import { PopupCoupon, PopupDiscountCardSkeleton } from "@shopflo/ui/popup";
import { useSearchParams } from "react-router-dom";
import { useMemo } from "react";
import { publishPostMessage } from "lib/utils/helpers";
import { eventTypes } from "lib/utils/constants";

interface PopupDiscountCardProps {
  authToken: string;
}

export const PopupDiscountCard: React.FC<PopupDiscountCardProps> = ({ authToken }) => {
  const [searchParams] = useSearchParams();
  const {
    state: { popup },
  } = useSSOContext();

  const requestId = searchParams.get("request-id");

  const { data, error, isValidating } = useSWR(
    "/sso/v1/sso/discounts",
    (url) =>
      postRequest(
        url,
        {
          request_id: requestId,
          extra: {
            utm: {
              source: "",
            },
          },
        },
        "CHECKOUT",
        {
          Authorization: authToken,
        },
      ),
    staticOptions,
  );

  const parsedData = useMemo(() => {
    if (data && data.length > 0) {
      const couponData = data[data.length - 1];
      const { coupon_details: couponDetails } = couponData;
      const props = {
        code: "",
        title: "",
        description: "",
        tagBackgroundColor: popup?.backgroundColor,
        tagTextColor: popup?.primaryCTA.color,
        tagText: "",
      };

      if (couponDetails.metadata) {
        const code = couponDetails.metadata?.code || "";
        const title = couponDetails.metadata?.title || "";
        const description = couponDetails.metadata?.description || "";
        const tagBackgroundColor = couponDetails.metadata?.tag_background_color || popup?.backgroundColor;
        const tagTextColor = couponDetails.metadata?.tag_text_color || popup?.primaryCTA.color;
        const tagText = couponDetails.metadata?.tag_text;
        props.code = code;
        props.title = title;
        props.description = description;
        props.tagBackgroundColor = tagBackgroundColor;
        props.tagTextColor = tagTextColor;
        props.tagText = tagText;
      }

      return props;
    }

    return {
      code: "",
      title: "",
      description: "",
      tagText: "",
      tagBackgroundColor: popup?.backgroundColor,
      tagTextColor: popup?.primaryCTA.color,
    };
  }, [data]);

  const copyParentCouponCode = (code: string) => {
    publishPostMessage(eventTypes.FLO_SSO_COUPON_CODE_COPIED, {
      code,
    });
  };

  if (error) return <></>;
  if (isValidating) return <PopupDiscountCardSkeleton />;

  return <PopupCoupon {...parsedData} handleCopyCouponCode={copyParentCouponCode} />;
};
